export default __webpack_public_path__ + "static/media/60.137031d9.jpeg";